'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  background: ', ';\n  border: 2px solid ', ';\n  height: 1em;\n  transition: all 200ms ease;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 1em;\n  margin-right: 0.75em;\n  flex-shrink: 0;\n  align-self: flex-start;\n'], ['\n  background: ', ';\n  border: 2px solid ', ';\n  height: 1em;\n  transition: all 200ms ease;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 1em;\n  margin-right: 0.75em;\n  flex-shrink: 0;\n  align-self: flex-start;\n']);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _config = require('../../../config.js');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Button = _styledComponents2.default.div(_templateObject, function (props) {
  return props.disabled ? _config.colors.gray : _config.colors.white;
}, _config.colors.gray);

Button.displayName = 'Button';

exports.default = Button;